import { useNavigate } from 'react-router-dom'

import ProfileHeader from 'components/ProfileHeader'

import { LuRoute } from 'react-icons/lu'
import { FiChevronRight, FiUser } from 'react-icons/fi'

const Main = () => {
  const navigate = useNavigate()

  return <section className="one hs air-2x gap-2x">

    <ProfileHeader />

    <ul className="list-menu">
      <li className="list-item" onClick={ () => navigate( '/profile' ) }>
        <span className="icon">
          <FiUser />
        </span>

        <span className="one text">profile</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>

      <li className="list-item" onClick={ () => navigate( '/routes' ) }>
        <span className="icon">
          <LuRoute />
        </span>

        <span className="one text">routes</span>

        <span className="icon">
          <FiChevronRight />
        </span>
      </li>
    </ul>
  </section>
}

export default Main
